import * as React from 'react'
import Navbar from '../setup/Navbar'
import { Container, Grid2, Typography } from '@mui/material'
import HeadingText from '../../BuiltInComponent/HeadingTest'
import { useDispatch, useSelector } from 'react-redux'
import { getClosingReport } from '../../features/AccountsReports/closingReportSlice'
import ClosingReportPDF from './ClosingReportPDF'
import Loading from '../../BuiltInComponent/Loading'
import DateTimePircker from '../../BuiltInComponent/DateTimePicker'
import dayjs from 'dayjs'

export default function ClosingReport() {

    const dispatch = useDispatch()
    const { cd, isLoading } = useSelector(state => state.clsngRpt)
    const { user } = useSelector(state => state.auth)
    React.useEffect(() => {
        dispatch(getClosingReport({ closingDate: '2025-04-10' }));
    }, [dispatch]);


    const [selectedDate, setSelectedDate] = React.useState(dayjs());

    const handleDateChange = async (newDate) => {
        setSelectedDate(newDate)
        dispatch(getClosingReport({ closingDate: newDate.format('YYYY-MM-DD') }))
    };

    return (
        <>
            <Navbar />
            <Container>
                <HeadingText text="Closing Report" />
                <Typography variant="h6" gutterBottom>
                    <Grid2 container spacing={2} >
                        <Grid2 size={4.5}></Grid2>
                        <Grid2 size={3} sx={{ alignSelf: 'center' }} >
                            <DateTimePircker
                                label="Pick a date"
                                value={selectedDate}
                                onChange={handleDateChange} />
                        </Grid2>
                        <Grid2 size={4.5}></Grid2>
                        <Grid2 size={3.5}></Grid2>
                        <Grid2 size={5}>
                            {isLoading ?
                                <Loading loadingText={'Closing Data'} /> :
                                cd && cd.length > 0 ?
                                    <ClosingReportPDF closingData={cd && cd} user={user} />
                                    : <div style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'center' }}>
                                        No Closing Data Found
                                    </div>}
                        </Grid2>
                        <Grid2 size={3.5}></Grid2>
                    </Grid2>
                    {/* {isLoading ? 'Loading...' : cd.map((item, index) => (
                        <ClosingReportPDF user={user} />
                        // <div key={index}>
                        //     <div>{dayjs(item.closingDate).format('DD-MMM-YYYY')}</div>
                        //     <div>{item.Quantity}</div>
                        //     <div>{item.Amount}</div>
                        // </div>
                    ))} */}
                </Typography>
            </Container>
        </>
    )
}